import {Component, OnInit, AfterViewInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {ThermostatcheckRequestService} from "../services/request.service";
import {ThermostatcheckAnfrage} from "../anfrage/thermostatcheck.anfrage";
/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-thermostatcheck-ausstieg',
    templateUrl: './thermostatcheck.ausstieg.component.html',
    standalone: false
})
export class ThermostatcheckAusstiegComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * (input) data of the user
   */
  anfrage: ThermostatcheckAnfrage;

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = "../../basisdaten/3";

  /**
   * define the case why we stop here.
   */
  case: string = null;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix: string = "thermostatcheck.eingabe.ausstieg";

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService,
              protected requestService: ThermostatcheckRequestService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get the input data
    this.anfrage = this.requestService.getAnfrage();

    // check if there is a last step given were we should navigate in case of the backstep to
    if(history?.state?.lastStep) {
      this.lastStep = history.state.lastStep;
    }

    if(this.anfrage?.userInput?.thermostatkopftyp === 'raum') {
      this.case = 'raumthermostat';
    }

  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element)
  }
}
